export default __webpack_public_path__ + "static/media/mile_end_alley.8c8ff307.jpg";